// /affiliates/story — the narrated pitch for becoming a Glonet affiliate, in
// the investor-overture style. Lands on /affiliates (the deal page). Copy law:
// no em or en dashes anywhere a visitor sees; numbers match the founding terms
// in affiliate_program_settings (50% x 12mo x 100 slots, cold-start D6).
// Person of address (owner ruling 2026-08-18): the story talks to the
// CONNECTOR from the first line; their audience is "your people". Tier
// honesty (2026-08-12): never promise Partner, only "if approved as a
// Partner". The posting-content slide is backed by the live share templates
// on /affiliates/dashboard (gtm_templates kind=share). The exclusive-nexus
// slide is a MAY-BE-INVITED opportunity coming in the next few months, not a
// committed program. If the owner edits the program, update SLIDES +
// narration together. Slide weights are MEASURED deciseconds from the
// render's character alignment (the render script prints them; paste them
// in) — guessed weights drift audibly over a 2.5 minute track. And
// BUMP the audio filename (story-vN.mp3): the browser caches the old track
// under the same URL and plays stale narration against new slides.
import React from "react";
import { useNavigate } from "react-router-dom";
import StoryOverture from "./StoryOverture";

export const AFFILIATE_SLIDES = [
  { w: 79, kind: "line", big: "Glonet.ai knows who your people need to meet.",
    sub: "Before they do. And it built the room where those meetings happen." },
  { w: 227, kind: "line", big: "The room never closes. We call it the water cooler.",
    sub: "Walk in at any hour and the conversation is already live, and you will know the moment your matches are there. And yes, it is very cool: games to play, themed spaces to explore, beaches, rooftops, even a secret tunnel." },
  { w: 116, kind: "line", big: "It is early access. Joining is free, for now.",
    sub: "Matching has not switched on yet. Early members roam the venue while the network fills. The day matching begins, everyone subscribes, and your early people lock in a discount." },
  { w: 75, kind: "line", big: "Every network is built by its connectors.",
    sub: "That is you. And this time, the connectors get paid." },
  { w: 107, kind: "line", big: "One link, with your name on it.",
    sub: "Everyone who joins through it is yours, credited and remembered. The day they start paying, you start earning." },
  { w: 171, kind: "stat", big: "50%", line: "of what your members pay, once matching begins.",
    sub: "Not a bounty, not a one-time bonus. Half of what each member actually pays, every month, for 12 months per member. Membership is estimated around $20 a month, and your people get theirs discounted." },
  { w: 144, kind: "line", big: "We write the posts. You press send.",
    sub: "Ready-made messages for email, LinkedIn, X and DMs sit in your dashboard, your link already inside. Copy, post, done." },
  { w: 139, kind: "stat", big: "100", line: "Partner slots. Every application reviewed.",
    sub: "Partners earn the 50% deal and keep it by performing. Apply in the first 90 days and if approved as a Partner, you start there." },
  { w: 199, kind: "line", big: "For the best of you, this is the opening act.",
    sub: "In the coming months, our highest performers may be invited to open their own exclusive nexus. Your network, your name on the door, terms that do not expire, an even better split. And your own water cooler, themed your way." },
  { w: 59, kind: "pills", hot: 3,
    items: ["make your case", "get approved", "share your link", "you earn"] },
  { w: 76, kind: "shot", src: "/affiliates/scoreboard.png", alt: "The Partner scoreboard",
    line: "Your scoreboard runs live.",
    sub: "Tier, quota, people, money. Nothing hidden." },
  { w: 47, kind: "line", big: "The next page is the deal in writing.",
    sub: "Read it. Make your case." },
];

export default function AffiliatesStory() {
  const navigate = useNavigate();
  return (
    <StoryOverture
      slides={AFFILIATE_SLIDES}
      audioSrc="/affiliates/audio/story-v9.mp3"
      tagline="Glonet · Founding Affiliates"
      gateTitle="Bring your people. Keep half."
      skipLabel="Skip to the deal"
      onDone={() => navigate("/affiliates")}
    />
  );
}
